import projectsServiceOld from  '../services/projectsServiceOld';
import locationsService from '../services/locationsService';
import analyticsService from '../services/analyticsService';

export default class ProjectsDataModel {

  /*************************************************************
   *
   *  Initialization
   *
   *************************************************************/

  constructor(store, dataModel) {
    this.store = store;
    this.dataModel = dataModel;
  }

  get stateTree() {
    return this.store.getState();
  }

  // These are all that're left

  resetUsersProjects(user_id) {
    if (this.stateTree.projects && this.stateTree.projects['usersProjects_' + user_id]) {
      let usersProjects = Object.assign({}, this.stateTree.projects['usersProjects_' + user_id].usersProjects);
      usersProjects.lastProjectsPage = 0;
      this.usersProjects = usersProjects;
    }
  }

  getUsersProjects(user_id) {
    if (this.stateTree.projects && this.stateTree.projects['usersProjects_' + user_id]) {
      return this.stateTree.projects['usersProjects_' + user_id].usersProjects;
    }
    else {
      return {};
    }
  }

  set usersProjects(usersProjects) {
    this.store.dispatch({
      type: 'SET_USERS_PROJECTS',
      usersProjects: usersProjects,
      user: usersProjects.user,
    });
  }

  fetchUsersProjects(user, callBack, samePage, customPerPage) {
    const oldProjects = this.getUsersProjects(user.id);
    let page = customPerPage ? 1 : samePage && oldProjects.lastProjectsPage ? oldProjects.lastProjectsPage : oldProjects.lastProjectsPage ? oldProjects.lastProjectsPage + 1 : 1;
    let perPage = customPerPage || 3;
    projectsServiceOld.getUserProjects(page, perPage, user).then(projects => {
      if (projects.error) {
        this.dataModel.displayHTTPError('Getting users projects', projects.error, false);
      }
      else {
        analyticsService.countMyTasks(user).then(taskData => {
          locationsService.getMyLocationsCount(user).then(locationsData => {
            const nextPageOfProjects = projects.projects || [];
            const currentProjects = (oldProjects && oldProjects.projects) ? oldProjects.projects : [];
            const newProjects = [...currentProjects, ...nextPageOfProjects];
            
            const usersProjects = projects ? {
              projects: newProjects,
              user: user,
              lastProjectsPage: projects.lastProjectsPage,
              totalProjects: projects.totalProjects,
              completedProjects: projects.completedProjects,
              notStartedCount: taskData.not_started_count,
              inProgressCount: taskData.in_progress_count,
              inReviewCount: taskData.in_review_count,
              allProjectsCount: taskData.all_count,
              locationsCount: locationsData.locations_count,
              activeLocationsCount: locationsData.active_locations_count,
            } : {};
            this.usersProjects = usersProjects;
            if (callBack) {
              callBack(usersProjects);
            }
          });
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/models/ProjectsDataModel.js